import React, { memo } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const UiSelect = (props) => {
     const { label, value, handleChange, options, defaultValue } = props;

     return (
          <FormControl fullWidth>
               <InputLabel id="demo-simple-select-label">{label}</InputLabel>
               <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value || options[0].value}
                    label={label}
                    defaultValue={defaultValue}
                    onChange={(e) => handleChange(e.target.value)}
               >
                    {options.map((item) => (
                         <MenuItem key={item.value} value={item.value}>
                              {item.label}
                         </MenuItem>
                    ))}
               </Select>
          </FormControl>
     );
};

export default UiSelect;
